import { getReviewProjectsRootPath } from "routes/plugins/review-projects/review-project-route-paths"
import { getLegislationResolutionsRootPath } from "routes/schedule/plugins/legislation-resolutions/legislation-resolution-route-paths"

export function getAuthoringRecommendationRouteToCurrentShell(item = {}) {
    const routeTo = `${item?.routeTo || ""}`
    if (!routeTo) return routeTo

    if (item?.sourceType === "reviewProject" && routeTo.startsWith("/app/review-projects")) {
        return routeTo.replace("/app/review-projects", getReviewProjectsRootPath())
    }

    if (item?.sourceType === "legislation" && routeTo.startsWith("/app/schedule-resolutions")) {
        return routeTo.replace("/app/schedule-resolutions", getLegislationResolutionsRootPath())
    }

    return routeTo
}
